
const UPDATE_CLIENT_CSS = "UPDATE_CLIENT_CSS";

const updateClient = css => {
  return dispatch => {
    dispatch({
      type: UPDATE_CLIENT_CSS,
      payload: css,
    });
  }
};

const clientReducer = (state = null, action) => {
  switch (action.type) {
    case UPDATE_CLIENT_CSS:
      const result = {
        ...state,
        ...action.payload,
      };
      return result;
    default:
      return state;
  }
};

export { clientReducer, updateClient, UPDATE_CLIENT_CSS };
